<template>
  <button type="button" @click="clickedButton" :class="[{ 'not-active': !buttonCanBeClicked }, variant]">
    <div :class="{ 'not-visible': !buttonCanBeClicked }">
      <slot></slot>
    </div>
  </button>
</template>
<script>
export default {
  props: {
    to: {
      type: Object,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    onClick: Function,
    buttonCanBeClicked: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clickedButton() {
      if (this.to) {
        this.$router.push(this.to);
      } else if (this.onClick && this.buttonCanBeClicked) {
        this.onClick();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
button {
  position: relative;
  background: var(--v-lightBlue-base);
  border: 3px solid rgba(175, 199, 255, 0.3);
  border-radius: 24px;
  text-align: center;
  text-transform: uppercase;
  padding: 5px 25px;
  color: #ffffff;
  box-shadow: 0px 0px 0px 3px rgba(175, 199, 255, 0.3);
  user-select: none;
  outline: none;
  font-weight: 900;
  &.white {
    background-color: #ffffff;
    color: var(--v-primary-base);
  }

  &.not-active {
    pointer-events: none;
    &:before {
      content: '';
      box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 20px;
      margin-top: -10px;
      margin-left: -10px;
      border-radius: 50%;
      border: 2px solid #fff;
      border-top-color: var(--v-primary-base);
      animation: spinner 0.6s linear infinite;
    }
  }
  &.navy{
    background-color: var(--v-navy-base);
    border-color: var(--v-navy-base);
    text-transform: none;
    box-shadow: none;
    font-size: 22px;
    padding: 0 40px;
    a{
      color: #fff;
      text-decoration: none;
    }
  }
  .not-visible {
    visibility: hidden;
  }
}
</style>
